import { CWF_DOCUMENT_TYPE_NAMES, CwfDocumentTypeName, Sku } from '@/api';

export const CWF_DOCS_TYPES_MAP: Record<Sku, CwfDocumentTypeName[]> = {
  '100': [],
  '200': [],
  '300': [],
  '350': [],
  '370': [CWF_DOCUMENT_TYPE_NAMES.ADVANCE_NEURO, CWF_DOCUMENT_TYPE_NAMES.BODY_COMPOSITION],
  '400': [],
  '900': [
    CWF_DOCUMENT_TYPE_NAMES.ADVANCE_HEART,
    CWF_DOCUMENT_TYPE_NAMES.ADVANCE_NEURO,
    CWF_DOCUMENT_TYPE_NAMES.BODY_COMPOSITION,
  ],
} as const;

export const CWF_DOCS_TYPE_NAME_MAP: Record<CwfDocumentTypeName, string> = {
  [CWF_DOCUMENT_TYPE_NAMES.ADVANCE_HEART]:
    'FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT_TYPES.DOCTYPE.HEART_HEALTH_ASSESSMENT',
  [CWF_DOCUMENT_TYPE_NAMES.ADVANCE_NEURO]:
    'FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT_TYPES.DOCTYPE.BRAIN_HEALTH_ASSESSMENT',
  [CWF_DOCUMENT_TYPE_NAMES.BLOOD_REPORT]:
    'FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT_TYPES.DOCTYPE.BLOOD_REPORT',
  [CWF_DOCUMENT_TYPE_NAMES.BODY_COMPOSITION]:
    'FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT_TYPES.DOCTYPE.BODY_COMPOSITION',
  [CWF_DOCUMENT_TYPE_NAMES.RADIOLOGY_REPORT]:
    'FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.RADIOLOGY_REPORT',
} as const;
